import { render, staticRenderFns } from "./Infor.vue?vue&type=template&id=370bd83e&scoped=true"
import script from "./Infor.vue?vue&type=script&lang=js"
export * from "./Infor.vue?vue&type=script&lang=js"
import style0 from "./Infor.vue?vue&type=style&index=0&id=370bd83e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370bd83e",
  null
  
)

export default component.exports